import React, { createContext, Dispatch, useReducer } from 'react';

import { HeaderActionsType, HeaderReducer } from './header/reducer';
import { HrefLangActionsType, HrefLangReducer } from './hrefLang/reducer';
import { JumplinkActionsType, JumplinkReducer } from './jumplinks/reducer';
import { LoadingActionsType, LoadingReducer } from './loading/reducer';
import { PageModelsActionsType, PageModelsReducer } from './pageModels/reducer';
import { StateType } from './store.interface';

const initialState: StateType = {
  jumplinks: [],
  loading: { loading: false, count: 0 },
  header: {
    height: 'auto',
  },
  pageModels: {
    config: {},
    labels: {},
    ready: false,
    taxonomy: {},
    httpStatusCode: '200',
    language: '',
    esCustomLabels: {},
    esLabels: {},
    langToRedirect: '',
  },
  hrefLang: [],
};

const AppContext = createContext<{
  state: StateType;
  dispatch: Dispatch<
    | JumplinkActionsType
    | LoadingActionsType
    | PageModelsActionsType
    | HeaderActionsType
    | HrefLangActionsType
  >;
}>({
  state: initialState,
  dispatch: () => null,
});

const mainReducer = (
  { jumplinks, loading, pageModels, header, hrefLang }: StateType,
  action: any,
) => ({
  jumplinks: JumplinkReducer(jumplinks, action),
  loading: LoadingReducer(loading, action),
  pageModels: PageModelsReducer(pageModels, action),
  header: HeaderReducer(header, action),
  hrefLang: HrefLangReducer(hrefLang, action),
});

const AppProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(mainReducer, initialState);

  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};

export { AppContext, AppProvider };
